import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Input, message, DatePicker, Row, Col, Select, ConfigProvider } from 'antd';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import axios from 'axios';
import api from '../../../services/api';
import * as ModalStatusAction from '../../../redux/actions/modalStatus'
import locale from 'antd/lib/locale/pt_BR';

interface ModalNovoOrgaoProps {
    modalStatus?: any,
    setNovoOrgaoModal?: any
}

const ModalNovoOrgao: React.FC<ModalNovoOrgaoProps> = (prop) => {
    let visible = prop.modalStatus[0].visibleNovoOrgao
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;
    const { TextArea } = Input;

    useEffect(() => {
        form.resetFields();
    }, [visible])

    const handleCancel = () => {
        prop.setNovoOrgaoModal(false)
    };

    const onFinish = (values: any) => {
        api.post(`Orgao`, {
            OrgaoID: undefined,
            Nome: values.nome,
            Sigla: values.sigla,
            Ativo: true,
        })
        .finally(()=>setLoading(true))
            .then((response) => {
                if (response.data.valido) {
                    message.success('Órgão salvo com sucesso')                    
                        setLoading(false);
                        prop.setNovoOrgaoModal(false);                    
                }
                else {
                    message.error(response.data.error)
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')               
            });

        
       
    };


    return (
        <Modal
            visible={visible}
            title="Novo Órgão"
            onCancel={handleCancel}
            footer={null}
        >
            <Form
                name="basic"
                form={form}
                onFinish={onFinish}
            >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Nome"
                            name="nome"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira um nome!',
                                }
                            ]}
                        >
                            <Input placeholder="Digite o Nome do Órgão" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Sigla"
                            name="sigla"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor insira uma Sigla!',
                                }
                            ]}
                        >
                            <Input placeholder="Digite a Sigla do Órgão" />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Button className="button-pre-cadastro" type="primary" htmlType="submit">
                        Finalizar
                    </Button>
                </Form.Item>
            </Form>
        </Modal >
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(ModalStatusAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(ModalNovoOrgao);